import { useContext, useCallback, useMemo } from "react";
import { LocalStorageContext } from "./LocalStorageContext";

export const useLocalStorage = () => {
  const ctx = useContext(LocalStorageContext);
  if (!ctx)
    throw new Error("useLocalStorage must be used within LocalStorageProvider");
  return ctx;
};

export const useLocalStorageData = <T>(
  key: string,
  defaultValue: T
): [T, (v: T) => void] => {
  const { get, set } = useLocalStorage();

  const value = useMemo(() => get(key) as T, [get, key]);

  const setValue = useCallback((value: T) => set(key, value), [set, key]);

  return [value || defaultValue, setValue];
};
